import React from "react";
import StaticPage from "../components/StaticPage";

const PAGES = {
  about: { kicker: "Company · About", title: "We engineer the next era of business.", body: [
    "MUNNEXA is a Singapore-born AI growth lab. We fuse strategy, AI, and automation into one living revenue system for ambitious SMEs across SEA.",
    "Our team blends ex-consultants, AI engineers, growth marketers, and product designers — operating as one unit embedded inside your business.",
    "Mission: make world-class AI infrastructure accessible to every operator, not just the Fortune 500.",
  ]},
  "case-studies": { kicker: "Company · Case Studies", title: "Real growth. Real numbers.", body: [
    "Browse a curated set of MUNNEXA client stories — from restaurants doubling repeat orders to clinics cutting no-shows by 62%.",
    "Each engagement is measured by hard outcomes: revenue, profit, hours saved, NPS lift.",
    "For the full deck and references, request a personalized walkthrough.",
  ]},
  careers: { kicker: "Company · Careers", title: "Build the future. With us.", body: [
    "We hire operators who love shipping. Generalists welcome.",
    "Open roles: AI Engineer, Growth Strategist, Product Designer, Customer Success Lead. Remote-friendly across SEA, hub in Singapore.",
    "Send us a note → careers@munnexa.ai",
  ]},
  press: { kicker: "Company · Press", title: "Press & media.", body: [
    "For interviews, product images, or analyst briefings — press@munnexa.ai",
    "MUNNEXA has been profiled in regional outlets covering SEA's AI adoption wave.",
  ]},
  privacy: { kicker: "Legal · Privacy", title: "Privacy Policy.", body: [
    "We respect your privacy. We collect only the data needed to deliver our services and never sell personal information to third parties.",
    "You may request access, correction, or deletion of your data at any time — contact privacy@munnexa.ai",
    "This policy aligns with Singapore's PDPA and the EU GDPR where applicable.",
  ]},
  terms: { kicker: "Legal · Terms", title: "Terms of Service.", body: [
    "By using MUNNEXA you agree to these terms. Services are provided on an as-is basis under the relevant master services agreement.",
    "Disputes are governed by the laws of Singapore.",
    "Full agreement provided upon engagement signing.",
  ]},
  dpa: { kicker: "Legal · DPA", title: "Data Processing Addendum.", body: [
    "Our DPA covers how MUNNEXA processes personal data on behalf of clients, including sub-processors and security obligations.",
    "Request a signed copy via legal@munnexa.ai",
  ]},
  security: { kicker: "Legal · Security", title: "Security at MUNNEXA.", body: [
    "We employ encryption in transit (TLS 1.3) and at rest, least-privilege access, audit logging, and quarterly penetration tests.",
    "AI workloads run on enterprise-grade providers (OpenAI, Anthropic, Google) with no client data retained for training.",
    "Annual SOC 2 Type II in progress (target 2026).",
  ]},
};

export default function InfoPage({ slug, openChat }) {
  const p = PAGES[slug] || PAGES.about;
  return (
    <StaticPage kicker={p.kicker} title={p.title} openChat={openChat}>
      {p.body.map((para) => (<p key={para.slice(0, 24)}>{para}</p>))}
    </StaticPage>
  );
}
